'use client'

import "../../../styles/tailwind.css"
import OrderSummaryComponent from "../../../pages/checkout/orderSummaryComponent";
import AddOns from "../addOns";
import FeaturesList from "./featuresList";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {readCart, saveCheckoutForm} from "../../../modules/checkoutHelpers";
import CheckoutNavigationSteps from "./checkoutNavigationSteps";
import {sendSlackMessageTracked} from "../../../models/notifications";
import {getIPAddress} from "../../../models/locationHelpers";


export default function CheckoutComponent() {
    const navigate = useNavigate()
    const [cartData, setCartData] = useState(null)

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [website, setWebsite] = useState("");

    useEffect(() => {
        sendSlackMessageTracked(`2️⃣ Visitor is visiting the checkout page.`)

        readCart((tempCartData) => {
            setCartData(tempCartData)
        })
    }, [])

    return (
        <div className="">
            <div className="mx-auto max-w-2xl px-4 pb-24 sm:px-6 lg:max-w-7xl lg:px-8">

                <div className="border-t border-gray-200 m-4">
                    <CheckoutNavigationSteps selectedIndex={0}/>
                </div>
                {/*<h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Checkout</h1>*/}

                <form className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16" onSubmit={(e) => e.preventDefault()}>
                    <div>

                        <div className="border-t border-gray-200 m-4">
                            <h2 className="text-lg font-bold text-gray-900">Fill in your information</h2>

                            <div className="mt-4">
                                <label htmlFor="email-address" className="block text-sm/6 font-medium text-gray-700">
                                    Email address <span className="text-red-600">*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="email-address"
                                        name="email-address"
                                        type="email"
                                        autoComplete="email"
                                        required={true}
                                        value={email}
                                        onChange={(e) => {setEmail(e.target.value)}}
                                        className="block w-full rounded-xl bg-white px-3 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="mt-4 gap-4 gap-y-6 space-y-4 p-4 pl-0">

                                <div className="flex space-x-2">
                                    <div className="w-full">
                                        <label htmlFor="first-name"
                                               className="block text-sm/6 font-medium text-gray-700">
                                            Full name
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="full-name"
                                                name="full-name"
                                                type="text"
                                                autoComplete="full-name"
                                                value={fullName}
                                                onChange={(e) => {setFullName(e.target.value)}}
                                                className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <label htmlFor="first-name"
                                               className="block text-sm/6 font-medium text-gray-700">
                                            Phone number
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                autoComplete="tel"
                                                value={phoneNumber}
                                                onChange={(e) => {setPhoneNumber(e.target.value)}}
                                                className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div className="sm:col-span-2">
                                    <label htmlFor="website" className="block text-sm/6 font-medium text-gray-700">
                                        Company website
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="website"
                                            name="website"
                                            type="text"
                                            value={website}
                                            onChange={(e) => setWebsite(e.target.value)}
                                            className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="">

                            <div className="mt-2 border-t border-gray-200 py-2"
                                 style={{
                                     // borderTop: "1px dotted",
                                     // borderBottom: "1px dotted",
                                 }}>
                                {/*<FeaturesList/>*/}
                            </div>
                            <div className="border-t border-gray-200">
                                <AddOns cartData={cartData} refreshCart={() => {
                                    readCart((tempCartData) => {
                                        setCartData(tempCartData)
                                    })
                                }}/>
                            </div>
                        </div>

                    </div>

                    {/* Order summary */}
                    <div className="mt-2">
                        <OrderSummaryComponent ctaString={"Continue to payment"} cartData={cartData} ctaAction={() => {
                            // Save form data synchronously so the payment page can read it immediately
                            const formData = {
                                type: "checkout_form",
                                name: fullName,
                                email: email,
                                phone_number: phoneNumber,
                                website: website,
                            };
                            saveCheckoutForm(formData);
                            navigate("/payment");

                            // Fire-and-forget: enrich with IP and post to server in background
                            getIPAddress((ipAddress) => {
                                const enriched = { ...formData, ip_address: ipAddress };
                                saveCheckoutForm(enriched);
                                fetch("https://server.pabloo.com/website/handle_submission", {
                                    method: "POST",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify(enriched),
                                });
                            });
                        }}/>
                    </div>


                </form>
            </div>
        </div>
    )
}
